<template>
    <div class="order-details">
        <div
            class="back"
            @click="back()"
            >{{ $t('general.return') }}
        </div>
        <div class="order">
            <div class="details" :class="market == 'ES' ? 'ES' : 'PT'">
                <div class="meta">
                    <div class="date">{{ $t('views.orders.date') }}{{ order.number }} {{ formatDate(order.date) }}</div>
                    <div class="status" :class="'s'+order.status">
                        <img :src="'/img/icons/status-' + order.status + '.png'" />
                        <span>{{ $t('views.orders.status.' + order.status) }}</span>
                    </div>
                </div>
                <div class="container">
                    <div class="col-1">
                        <h3 class="subtitle">{{ $t('views.orders.summary') }}</h3>
                        <div class="orders">
                            <div v-for="(item, index) in order.items" class="item" :key="item.id">
                                <img class="image" :src="item.from.image" />
                                <div class="content">
                                    <div class="to">
                                        <div class="name">{{item.from.filename}} <span class="print" v-if="item.method === 2">{{ $t('views.orders.production') }}</span></div>
                                        <div class="param"><span class="label">{{ $t('general.unit') }}</span>{{ units(item) }}</div>
                                        <div class="param"><span class="label">{{ $t('general.send_to') }}</span>{{ order.restaurant_site + ' - ' + order.restaurant_name }}</div>
                                        <div class="param" v-if="item.billed !== -1"><span class="label">{{ $t('general.invoice') }}</span>{{ getRestaurantById(item.billed) }}</div>
                                        <div class="param" v-if="item.custom.restaurant"><span class="label">{{ $t('general.restaurant') }}</span>{{ item.custom.restaurant }}</div>
                                        <div class="param" v-if="item.custom.price"><span class="label">{{ $t('general.price') }}</span>{{ item.custom.price }}</div>
                                        <div class="param" v-if="item.custom.legal"><span class="label">{{ $t('views.order.customize.legal') }}</span>{{ item.custom.legal }}</div>
                                        <div class="param" v-if="item.custom.others"><span class="label">{{ $t('admin.views.order.others') }}</span>{{ item.custom.others }}</div>
                                        <div class="param" v-if="item.custom.start_date"><span class="label">{{ $t('general.start_date') }}</span>{{ formatDateDays(item.custom.start_date) }}</div>
                                        <div class="param" v-if="item.custom.end_date"><span class="label">{{ $t('general.end_date') }}</span>{{ formatDateDays(item.custom.end_date) }}</div>
                                        <div class="param direction-row" v-if="item.custom.direction && item.custom.direction.text"><span class="label">{{ $t('general.direction') }}</span><img :src="item.custom.direction.image" />{{ item.custom.direction.text }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <h3 class="subtitle">{{ $t('general.contact') }}</h3>
                        <div class="contact">
                            <div class="param"><span class="label">{{$t('general.name')}}:</span>{{order.contact_name}}</div>
                            <div class="param"><span class="label">{{$t('general.email')}}:</span>{{order.contact_email}}</div>
                            <div class="param" v-if="order.contact_phone"><span class="label">{{$t('general.phone')}}:</span>{{order.contact_phone}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chat">
                <OrderChat :order_id="order.id" type="other" />
            </div>
        </div>
    </div>
</template>

<script>
import OrderChat from '@/components/domain/order/chat.vue';

export default {
    name: 'OrderDetails',
    components: {
        OrderChat
    },
    data() {
        return {
            order: null,
            sizes: this.$store.getters['orders/getSizes']
        }
    },
    computed: {
        locations() {
            return this.$store.getters['locations/getLocations']
        },
        market() {
            return this.$store.getters['getMarket'];
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format("HH:mm DD/MM/YYYY");
        },
        formatDateDays(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        loadOrder() {
            const orderId = this.$route.params.id;
            const orders = this.$store.getters['orders/getOrders'];
            this.order = orders[orderId];
        },
        back() {
            this.$router.push({ name: 'orders' });
        },
        units(item) {
            if (item.method === 2) {
                if (item.units_scale !== null) {
                    return item.units_scale;
                } else if (item.units_scale_custom !== null) {
                    return item.units_scale_custom;
                } else {
                    return 1;
                }
            } else {
                var units = item.units !== null ? item.units : 1;
                return units;
            }
        },
        getRestaurantById(id) {
            const locations = this.$store.getters['locations/getLocations'];
            return locations[id].site + ' - ' + locations[id].name;
        }
    },
    created() {
        this.loadOrder();
    },
    watch: {
        '$route.params.id': {
            handler: 'loadOrder',
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.order-details {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 24px;
    padding: 24px;
    width: 100%;
    
    .back {
        background: url(/img/left-arrow.svg) no-repeat left center;
        text-align: left;
        margin-bottom: 20px;
        padding-left: 25px;
        cursor: pointer;
    }
    .order {
        display: flex;
        flex-direction: row;
        width: 100%;
        gap: 24px;
    

        .details {
            width: 50%;
            border: 1px solid #ccc;
            border-radius: 4px;
            &.ES {
                width: 100%;
            }
            
            .meta {
                text-align: left;
                background: #ddd;
                padding: 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .date {
                    font-family: Speedee-Bold;
                    font-size: 24px;
                }

                .status {
                    display: inline-block;
                    background: #ccc;
                    border-radius: 4px;
                    padding: 6px 16px;
                    font-size: 14px;
                    color: #111;
                    display: flex;
                    align-items: center;
                    
                    img {
                        height: 16px;
                        width: 16px;
                        margin-right: 4px;
                    }

                    &.s1 {
                        background-color: black;
                        color: white;
                        > img {
                            filter: brightness(0) invert(1);
                        }
                    }

                    &.s2 {
                        background-color: #FFFFFF;
                        color: #111111;
                    }

                    &.s3 {
                        background-color: #ffeb3b;
                        color: #111111;
                    }
                    
                    &.s4 {
                        background-color: #96d6be;
                        color: #111111;
                    }

                    &.s5 {
                        background-color: #ff9e80;
                        color: #111111;
                    }
                }
            }

            .container {
                display: flex;
                flex-direction: column;
                overflow: hidden;
                padding: 36px;

                .col-1 {
                    .subtitle {
                        font-weight: normal;
                        font-size: 14px;
                    }

                    .orders {
                        .item {
                            display: flex;
                            gap: 16px;
                            margin-bottom: 16px;

                            .image {
                                width: 80px;
                                height: 80px;
                                object-fit: cover;
                            }

                            .content {
                                flex: 1;

                                .to {
                                    .name {
                                        font-family: Speedee-Bold;
                                        margin-bottom: 8px;

                                        .print {
                                            background: var(--main_color);
                                            padding: 3px 10px;
                                            border-radius: 15px;
                                            font-size: 10px;
                                            margin-left: 10px;
                                        }
                                    }

                                    .label {
                                        display: inline-block;
                                        width: 150px;
                                        margin-bottom: 4px;
                                        color: #999999;
                                    }

                                    .size {
                                        font-size: 13px;
                                        color: #666;
                                    }

                                    .direction-row {
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 4px;

                                        .label {
                                            display: inline-block;
                                            width: 150px;
                                            color: #999999;
                                        }

                                        img {
                                            margin-right: 4px;
                                            width: 20px;
                                            height: 20px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                .col-2 {
                    border-top: 1px solid #ccc;
                    .subtitle {
                        font-weight: normal;
                        font-size: 14px;
                        margin: 8px 0;
                    }
                    .contact {
                        .param {
                            margin-bottom: 8px;
                            font-size: 14px;

                            .label {
                                display: inline-block;
                                width: 100px;
                                color: #999999;
                                margin-right: 8px;
                            }
                        }
                    }
                }
            }
        }

        .chat {
            width: 50%;
            height: 500px;
        }
    }
}
</style>
